import React, { ReactElement } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const CheckboxRoundActiveIcon = (props: SvgIconProps & { fillColor?: string }): ReactElement => {
    const { fillColor, ...rest } = props;
    return (
        <SvgIcon viewBox="0 0 24 24" {...rest}>
            <circle cx="12" cy="12" r="12" fill={fillColor ?? '#2196F3'} />
            <path
                d="M18 7.95001L9.75 16.2L6 12.45"
                stroke="white"
                fill="none"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SvgIcon>
    );
};
